var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6854_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2797 13.3798C15.9787 13.3798 18.9774 10.3846 18.9774 6.6899C18.9774 2.99517 15.9787 0 12.2797 0C8.58068 0 5.58203 2.99517 5.58203 6.6899C5.58203 10.3846 8.58068 13.3798 12.2797 13.3798Z",
    fill: "#036C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8622 18.9548C21.253 18.9548 24.0017 16.2092 24.0017 12.8223C24.0017 9.43551 21.253 6.68994 17.8622 6.68994C14.4714 6.68994 11.7227 9.43551 11.7227 12.8223C11.7227 16.2092 14.4714 18.9548 17.8622 18.9548Z",
    fill: "#1A9BA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1153 23.4148C15.7354 23.4148 17.8595 21.2933 17.8595 18.6762C17.8595 16.0591 15.7354 13.9375 13.1153 13.9375C10.4951 13.9375 8.37109 16.0591 8.37109 18.6762C8.37109 21.2933 10.4951 23.4148 13.1153 23.4148Z",
    fill: "#37C6D0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.397 6.03779V17.9346C13.3942 18.348 13.1434 18.7194 12.7607 18.8768C12.6388 18.9283 12.5079 18.9548 12.3756 18.9549H8.37929C8.37372 18.8601 8.37372 18.7709 8.37372 18.6761C8.37186 18.5831 8.37558 18.49 8.38488 18.3974C8.48704 16.6153 9.58614 15.043 11.2258 14.3332V13.2963C7.57664 12.7187 5.08718 9.29567 5.66546 5.65074C5.66947 5.62549 5.67361 5.60026 5.67791 5.57507C5.70569 5.38705 5.74484 5.20088 5.79512 5.01758H12.3756C12.9388 5.01972 13.3948 5.47523 13.397 6.03779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8176 5.57471H5.67802C5.05781 9.21307 7.50793 12.6647 11.1505 13.2842C11.2608 13.303 11.3716 13.319 11.4827 13.3322C9.75244 14.1517 8.4916 16.4792 8.38444 18.397C8.37515 18.4896 8.37142 18.5827 8.37327 18.6757C8.37327 18.7705 8.37327 18.8597 8.37885 18.9545C8.38892 19.1419 8.41318 19.3283 8.4514 19.512H11.817C12.2309 19.5092 12.6027 19.2587 12.7602 18.8764C12.8118 18.7547 12.8384 18.6239 12.8384 18.4918V6.59492C12.8363 6.03258 12.3806 5.57716 11.8176 5.57471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8175 5.57471H5.67797C5.0579 9.21341 7.50839 12.6652 11.1513 13.2846C11.2258 13.2973 11.3006 13.3087 11.3755 13.3188C9.70105 14.1974 8.48989 16.5194 8.38496 18.397H11.8175C12.3798 18.3928 12.8347 17.9385 12.8389 17.3768V6.59492C12.8368 6.03236 12.3807 5.57685 11.8175 5.57471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2592 5.57471H5.67779C5.09227 9.00968 7.24715 12.3176 10.6285 13.1744C9.34815 14.6356 8.56286 16.4635 8.38477 18.397H11.2592C11.8224 18.3949 12.2784 17.9394 12.2806 17.3768V6.59492C12.2803 6.03161 11.8232 5.57502 11.2592 5.57471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02307 5.57471H11.256C11.821 5.57471 12.2791 6.03222 12.2791 6.59659V16.8176C12.2791 17.382 11.821 17.8395 11.256 17.8395H1.02307C0.458044 17.8395 0 17.382 0 16.8176V6.59659C0 6.03222 0.458044 5.57471 1.02307 5.57471Z",
    fill: "url(#paint0_linear_6854_23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57127 11.5825C4.33152 11.4237 4.13125 11.2122 3.98578 10.9643C3.84483 10.7051 3.77457 10.4134 3.78205 10.1185C3.7695 9.71931 3.90438 9.32941 4.16103 9.02308C4.43072 8.71638 4.77931 8.48926 5.16903 8.36635C5.61318 8.22033 6.07839 8.14838 6.54595 8.15339C7.16083 8.13095 7.77484 8.21683 8.3599 8.40706V9.68929C8.10569 9.53547 7.82881 9.42258 7.53944 9.3548C7.22545 9.27789 6.90328 9.23932 6.58 9.23995C6.23909 9.22745 5.90036 9.29906 5.59376 9.44845C5.35706 9.55043 5.20356 9.78303 5.20307 10.0405C5.20211 10.1967 5.26218 10.3471 5.37051 10.4597C5.49847 10.5925 5.64983 10.7006 5.81703 10.7786C6.00307 10.8712 6.28214 10.9942 6.65424 11.1477C6.6952 11.1606 6.73514 11.1767 6.77367 11.1956C7.13989 11.3386 7.49318 11.5126 7.82968 11.7158C8.0845 11.8727 8.29837 12.0879 8.45368 12.3435C8.61291 12.6333 8.69009 12.9609 8.67693 13.2913C8.69511 13.7011 8.56957 14.1045 8.32196 14.4319C8.07516 14.7328 7.74519 14.9546 7.37312 15.0697C6.93549 15.2067 6.47875 15.2729 6.02019 15.2659C5.60876 15.2677 5.19794 15.2342 4.79228 15.1655C4.44976 15.1095 4.1155 15.0114 3.79712 14.8734V13.5215C4.10146 13.7386 4.44146 13.9009 4.80177 14.0009C5.16087 14.1127 5.53416 14.1724 5.91024 14.1782C6.25831 14.2002 6.60577 14.1266 6.91489 13.9653C7.13143 13.8432 7.26313 13.612 7.25759 13.3637C7.25904 13.191 7.19062 13.0249 7.06783 12.9032C6.91513 12.7535 6.73834 12.6305 6.54486 12.5392C6.3216 12.4277 5.99285 12.2807 5.55862 12.0982C5.21318 11.9595 4.88242 11.7868 4.57127 11.5825Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6854_23",
    x1: 2.13312,
    y1: 4.77623,
    x2: 10.132,
    y2: 18.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#038489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026D71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6854_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.4146,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/sharepoint.8b4e6574b20e379c0d5b2010a06f4fc7.svg";
export { ForwardRef as ReactComponent };